function readCookie(name) {
  if (typeof document === "undefined") return "";

  const prefix = `${encodeURIComponent(name)}=`;
  const cookie = document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(prefix));

  return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : "";
}

function toPositiveInteger(value) {
  const number = Number(value);
  return Number.isInteger(number) && number > 0 ? number : 0;
}

export function getCurrentCustomerId() {
  return toPositiveInteger(readCookie("user_id"));
}

export function getCurrentOfficeId() {
  return toPositiveInteger(readCookie("office_id"));
}

export function getCustomerScopedStorage(baseKey) {
  if (typeof window === "undefined") return { storage: null, key: baseKey };

  const customerId = getCurrentCustomerId();
  if (customerId > 0) {
    return {
      storage: window.localStorage,
      key: `luvmom.customer.${customerId}.${baseKey}`,
    };
  }

  return {
    storage: window.sessionStorage,
    key: `luvmom.preview.${baseKey}`,
  };
}

export function resolveScheduleOfficeId(schedule) {
  return toPositiveInteger(schedule?.officeId ?? schedule?.office_id) || getCurrentOfficeId();
}
